//
//
// common utility functions
//
//
import { ItemStatus } from 'containers/style_detail/constant';
import moment from 'moment';
import { EGENDER, EQuestionId, EQuizId, ESubjectQuestion } from 'types/quiz';
import isUrl from 'validator/lib/isURL';
import { getAnchorNewTab, getComingSoonElement, getTrimmedStyle } from './utils_helper';
import Bugsnag from '@bugsnag/js';
import { store } from 'redux/store';
import { history } from 'index';
import { NotificationVerb, STORE_DEV_MODE_ATTR } from '../constants';
import { WIDGET_CONSTANTS } from '../constants/iframe-events';
import { PATH } from 'routes/constant';
import config from 'config';
import { FetchPolicy, MutationFetchPolicy, WatchQueryFetchPolicy } from '@apollo/client/core/watchQueryOptions';
import constant, { LOCAL_STORAGE_KEY } from './constant';
import difference from 'lodash/difference';
import intersection from 'lodash/intersection';
import differenceWith from 'lodash/differenceWith';
import isEqual from 'lodash/isEqual';
import { TRACK_EVENT, trackEvent } from './analytics';
import { database } from '../firebase';
import { Slack } from 'react-slack-webhook';
import { isMobile } from 'react-device-detect';
import { DynamicLayoutVersion } from 'types/types';

const TaffiNameStr = 'Taffi';

interface IGqlMutationOption {
    fetchPolicy?: MutationFetchPolicy;
    onCompleted?: (any) => void;
    onError?: (any) => void;
}
interface IGqlQueryOption {
    fetchPolicy?: FetchPolicy | WatchQueryFetchPolicy;
    onCompleted?: (any) => void;
    onError?: (any) => void;
    variables?: any;
    skip?: boolean;
}

export type keyValueObject = {
    [key: string]: any;
};
export function ValidURL(str) {
    return isUrl(str, {
        require_protocol: true,
        require_valid_protocol: true,
        protocols: ['http', 'https'],
    });
}
// const getAnchorNewTab = function(
//     url: string,
//     text: string,
//     style: keyValueObject){
//         return <a href={url} target="blank" style={style}>{text}</a>;
// };

// const getComingSoonElement = function(style: keyValueObject){
//     return <span style={{
//         fontSize: 14,
//         fontWeight: 400,
//         fontFamily: "PoppinsRegular",
//         margin: "4px 0",
//         textDecoration: "none",
//         float: "right",
//         opacity: 0.5,
//         ...style,
//     }}>[coming soon]</span>;
// }

const getHostUrl = (port: boolean): string => {
    let host = `${window.location.protocol}//${window.location.hostname}`;
    return host + (port && window.location.port ? `:${window.location.port}` : '');
};

export const getValueSelect = (data) => {
    if (data) {
        return {
            id: data.id,
            subject: data.subject,
            value: data.value || data.name,
            name: data.value || data.name,
            label: data.value || data.name,
            descriptions: data?.descriptions,
            imageUrl: data?.imageUrl,
        };
    }
    return data;
};

export const getValueImageSelect = (data) => ({
    id: data.id,
    value: data.value || data.name,
    name: data.value || data.name,
    label: data.value || data.name,
    imageUrl: data.imageUrl,
    description: data?.description,
});
export const getValueDescription = (data) => ({
    id: data.id,
    value: data.value || data.title,
    label: data.value || data.title,
    bgColor: data?.descriptions[0],
    color: data?.descriptions[1],
    description: data?.descriptions[2] || '',
    isSelect: false,
});

export const getValueTags = (data) => ({
    id: data.id,
    value: data.value || data.title,
    tags: data.tags,
    isSelect: false,
});
export const getViewStyleNotificationParams = ({ me, activeStyle, stylist }) => ({
    actionObjectId: activeStyle?.id,
    actionObjectType: 'styles',
    targetObjectId: activeStyle?.taffiId,
    targetObjectType: 'styles',
    actor: me?.id,
    message: `${me?.firstName} has viewed your style`,
    recipient: stylist?.id,
    verb: NotificationVerb.CustomerViewedStyle,
    channels: ['inapp', 'whatsapp'],
    channelInfo: [
        {
            channel: 'whatsapp' as any,
            templateName: 'consumer_reaction_notification_to_stylist',
            parameters: [
                {
                    default: stylist?.firstName,
                },
                {
                    default: me?.firstName,
                },
                {
                    default: 'viewed',
                },
                {
                    default: 'style',
                },
                {
                    default: utils.getShareEntityUrl('/style', activeStyle?.taffiId, false),
                },
                {
                    default: `${utils.getHostUrl(process.env.NODE_ENV === 'development')}${PATH.PROFILE}/${
                        me.userName
                    }`,
                },
            ],
        },
    ],
});

export const getSkinUndertoneValue = (data) => {
    const { descriptions = [], id, title, value } = data;
    const [subTitle, ...gradientColors] = descriptions;

    return {
        id,
        value: value || title,
        title,
        subTitle,
        gradientColors,
        isSelect: false,
    };
};

export const getAnswerValues = (data) => {
    return {
        ...data,
        isSelect: false,
    };
};

export const isValidDate = (date) => {
    const d = moment(date);
    return d.isValid();
};

const addAffiliateToUrl = (url: URL, affiliateLink = '') => {
    if (affiliateLink) {
        const affiliateUrl = new URL(affiliateLink);
        affiliateUrl?.searchParams?.forEach((value, name) => {
            if (!url.searchParams.has(name)) {
                url.searchParams.append(name, value);
            }
        });
    }
    return url;
};

const getEntityUrl = (path: string, taffiId: string): string => {
    return `${getHostUrl(process.env.NODE_ENV === 'development')}${path}/${taffiId}`;
};

const getShareEntityUrl = (path: string, taffiId: string, considerWidget: boolean = true): string => {
    if (isAppInWidgetMode() && considerWidget) {
        const globalState = store.getState();
        const storeSourceUrl = globalState?.widget?.sourceUrl;
        let widgetTaffiUrl = new URL(storeSourceUrl);
        const shopifyStore = globalState?.widget?.store;
        widgetTaffiUrl = addAffiliateToUrl(widgetTaffiUrl, shopifyStore?.affiliateLink);
        let taffiPath = `${path}/${taffiId}`;
        if (window.location.pathname.includes(PATH.DISCOVER_YOUR_STYLE)) {
            taffiPath = `${PATH.DISCOVER_YOUR_STYLE}?taffiId=${taffiId}`;
        }
        if (window.location.pathname.includes(PATH.STYLE_IT_RIGHT)) {
            taffiPath = `${PATH.STYLE_IT_RIGHT}?taffiId=${taffiId}&sourceProductUrl=${storeSourceUrl}`;
        }
        if (widgetTaffiUrl.searchParams.get(config.widgetConstants.TAFFI_PATH)) {
            widgetTaffiUrl.searchParams.set(config.widgetConstants.TAFFI_PATH, taffiPath);
        } else {
            widgetTaffiUrl.searchParams.append(config.widgetConstants.TAFFI_PATH, taffiPath);
        }
        return widgetTaffiUrl.href;
    }
    return `${getHostUrl(process.env.NODE_ENV === 'development')}/share${path}/${taffiId}`;
};

const getShareEntityUrlWithParams = (path: string, taffiId: string, params: string, styleTaffiId: string): string => {
    if (isAppInWidgetMode()) {
        const globalState = store.getState();
        const storeSourceUrl = globalState?.widget?.sourceUrl;
        let widgetTaffiUrl = new URL(storeSourceUrl);
        const shopifyStore = globalState?.widget?.store;
        widgetTaffiUrl = addAffiliateToUrl(widgetTaffiUrl, shopifyStore?.affiliateLink);
        if (window.location.pathname.includes(PATH.DISCOVER_YOUR_STYLE)) {
            widgetTaffiUrl.searchParams.append(
                config.widgetConstants.TAFFI_PATH,
                `${PATH.DISCOVER_YOUR_STYLE}?taffiId=${styleTaffiId}`,
            );
        } else {
            widgetTaffiUrl.searchParams.append(
                config.widgetConstants.TAFFI_PATH,
                `/style/${styleTaffiId}/?itemId=${taffiId}`,
            );
        }
        return widgetTaffiUrl.href;
    }
    return `${getHostUrl(process.env.NODE_ENV === 'development')}/share${path}/${taffiId}?${params}`;
};

const generateUrlFromPath = (path: string): string => {
    if (isAppInWidgetMode()) {
        const globalState = store.getState();
        const storeSourceUrl = globalState?.widget?.sourceUrl;
        let widgetTaffiUrl = new URL(storeSourceUrl);
        const shopifyStore = globalState?.widget?.store;
        widgetTaffiUrl = addAffiliateToUrl(widgetTaffiUrl, shopifyStore?.affiliateLink);
        widgetTaffiUrl.searchParams.append(config.widgetConstants.TAFFI_PATH, `${path}`);
        return widgetTaffiUrl.href;
    }
    return `${getHostUrl(process.env.NODE_ENV === 'development')}${path}`;
};

const getCorsProxyUrl = () => {
    return process.env.REACT_APP_USE_EMULATORS
        ? `${utils.getHostUrl(false)}:5001/taffi-stage/us-central1/corsproxy`
        : `https://us-central1-${process.env.REACT_APP_PROJECT_ID}.cloudfunctions.net/corsproxy`;
};

const cleanUrl = (url) => {
    let rl = url.replace(/\/\//g, '/');
    rl = url.replace(/([^:]\/)\/+/g, '$1');
    return rl;
};

const getCorsAnyWhereUrl = (url: string): string => {
    // Project id is the first part of the url
    const projectId = `${process.env.REACT_APP_PROJECT_ID}`;
    const storageCdn = `${process.env.REACT_APP_STORAGE_CDN}`;

    // Check project id is in the url
    if (url.toString().indexOf(projectId) !== -1) {
        return url;
    }

    // Skip proxy server for taffi cdns
    if (url.toString().indexOf(storageCdn) !== -1) {
        return url;
    }

    // Remove protocol from url
    let _url = url.replace('https://', '');
    _url = _url.replace('http://', '');

    // // Check url starts with www.
    // if (_url.indexOf("www.") === 0) {
    //     _url = _url.replace("www.", "");
    // }

    // console.log("_url", _url);

    // Url String
    let corsUrl = getCorsProxyUrl() + '/' + _url.toString();

    corsUrl = cleanUrl(corsUrl);
    corsUrl = new URL(corsUrl).toString();

    return corsUrl;
};

const objToList = (objList: keyValueObject[], field: string): any[] => {
    return objList.filter((el) => field in el).map((el) => el[field]);
};

const DEFAULT_FLOAT_PRECISION = 2;
const getPreciseFloat = (n: number, p: number = DEFAULT_FLOAT_PRECISION) => {
    return n?.toFixed(p);
};

const checkCurrentPage = (page: string) => {
    return window.location.pathname === page;
};
const getPrice = (amount: any, currency) => {
    const formatter = new Intl.NumberFormat('en-US', {
        currency: currency ? currency : 'SAR',
        style: 'currency',
    });

    return formatter.format(amount);
};
const capitalizeString = (str, lower = false) =>
    (lower ? str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, (match) => match.toUpperCase());
const sortFilterObjectArray = (a, b) => {
    return a.value.localeCompare(b.value);
};
const getSessionStartandEndTime = (startTime, endTime) => {
    const sessionStartTime = getSessionStartTimeDisplay(startTime);
    const sessionEndTime = moment(endTime).format('hh:mma');
    return sessionStartTime + ' - ' + sessionEndTime;
};

export const getSessionSchedulingStartTime = (startTime) => {
    const formatted = moment(startTime).format('DD MMM YYYY, h:mm a');
    return formatted;
};

const getSessionStartTimeDisplay = (startTime) => {
    const sessionStartTime = moment(startTime).format('D MMMM YYYY, hh:mma');
    return sessionStartTime;
};
export const getPersonaSubject = (gender) => {
    if (gender && (gender.toLowerCase() === 'man' || gender.toLowerCase() === 'male')) {
        return ESubjectQuestion.PERSONAS_MALE_SUBJECT;
    } else {
        return ESubjectQuestion.PERSONAS_FEMALE_SUBJECT;
    }
};
export const getPatternSubject = (gender) => {
    if (gender && (gender.toLowerCase() === 'man' || gender.toLowerCase() === 'male')) {
        return ESubjectQuestion.PATTERN_MALE_SUBJECT;
    } else {
        return ESubjectQuestion.PATTERN_FEMALE_SUBJECT;
    }
};
export const getFashionRestrictionSubject = (gender) => {
    if (gender && (gender.toLowerCase() === 'man' || gender.toLowerCase() === 'male')) {
        return ESubjectQuestion.FASHION_RESTRICTION_MALE_SUBJECT;
    } else {
        return ESubjectQuestion.FASHION_RESTRICTION_FEMALE_SUBJECT;
    }
};
export const getPersonaQuiz = (gender) => {
    if (gender && (gender.toLowerCase() === 'man' || gender.toLowerCase() === 'male')) {
        return EQuizId.PERSONAS_MALE_QUIZ;
    } else {
        return EQuizId.PERSONAS_FEMALE_QUIZ;
    }
};
export const getPatternQuizId = (gender) => {
    if (gender && (gender.toLowerCase() === 'man' || gender.toLowerCase() === 'male')) {
        return EQuizId.PATTERN_QUIZ_MAN;
    } else {
        return EQuizId.PATTERN_QUIZ_WOMAN;
    }
};
export const getPersonaQuestion = (gender) => {
    if (gender && (gender.toLowerCase() === 'man' || gender.toLowerCase() === 'male')) {
        return EQuestionId.PERSONAS_MALE_ID;
    } else {
        return EQuestionId.PERSONAS_FEMALE_ID;
    }
};
export const getFashionRestrictionQuizId = (gender) => {
    //need to change
    if (gender && (gender.toLowerCase() === 'man' || gender.toLowerCase() === 'male')) {
        return EQuizId.FASHION_RESTRICTION_QUIZ_MAN;
    } else {
        return EQuizId.FASHION_RESTRICTION_QUIZ_WOMAN;
    }
};

export const getMeasurementQuizId = (gender) => {
    if (gender && (gender.toLowerCase() === 'man' || gender.toLowerCase() === 'male')) {
        return EQuizId.MEASUREMENTS_QUIZ_MALE;
    } else {
        return EQuizId.MEASUREMENTS_QUIZ_FEMALE;
    }
};

export const getStyleQuizId = (gender) => {
    if (gender && (gender.toLowerCase() === 'man' || gender.toLowerCase() === 'male')) {
        return EQuizId.STYLE_QUIZ_MAN;
    } else {
        return EQuizId.STYLE_QUIZ_WOMAN;
    }
};

export const getSizeQuizId = (gender) => (gender === EGENDER.MALE ? EQuizId.SIZES_MALE : EQuizId.SIZE_FEMALE);

export const getDynamicWidth = (actualWidth) => {
    let defaultScreenWidth = 375; //width of the screen size from figma
    if (window.innerWidth < defaultScreenWidth) {
        return actualWidth * (window.innerWidth / defaultScreenWidth);
    } else {
        return actualWidth;
    }
};

export const getDynamicHeight = (height, width) => {
    let elementWidth = getDynamicWidth(width);
    if (elementWidth !== width) {
        return elementWidth * (height / width);
    } else {
        return height;
    }
};

export const getBudgetQuizId = (gender) => {
    if (gender && (gender.toLowerCase() === 'man' || gender.toLowerCase() === 'male')) {
        return EQuizId.BUDGET_MAN_QUIZ;
    } else {
        return EQuizId.BUDGET_WOMAN_QUIZ;
    }
};
export const isMale = (gender: string) => {
    if (gender && (gender.toLowerCase() === 'man' || gender.toLowerCase() === 'male')) {
        return true;
    } else {
        return false;
    }
};

export const renderTitleWarningEditStyle = (status: ItemStatus, type: string, styleData: any) => {
    const url = utils.getShareEntityUrl('/style', styleData?.taffiId, false);
    switch (status) {
    case ItemStatus.Published:
        return `The style will be unpublished from Taffi and need to be published again. Do you want to continue to edit the ${type}?`;
    case ItemStatus.PublishToConsumers:
        let consumerName = '';
        if (styleData?.consumers?.length) {
            consumerName = styleData?.consumers.reduce(
                (currentName, currentItem) =>
                    `${currentName ? `${currentName}, ` : ''}${currentItem.firstName + ' ' + currentItem.lastName}`,
                '',
            );
        }
        return `The style will be unpublished from Taffi and need to be published again to be available to ${consumerName} via the link ${url}. Do you want to continue to edit the ${type}?`;
    case ItemStatus.PublishToUnlisted:
        return `The style will be unpublished from Taffi and need to be published again to be available via the link. Do you want to continue to edit the ${type}?`;
    default:
        return '';
    }
};

export const isValidIp = (host: string) => {
    const isValidIp = /^(?:(?:^|\.)(?:2(?:5[0-5]|[0-4]\d)|1?\d?\d)){4}$/.test(host) ? true : false;
    const isValidIPWithPort =
        /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]):[0-9]+$/.test(
            host,
        )
            ? true
            : false;
    return isValidIp || isValidIPWithPort;
};

export const bugSnagReport = (error: any, context?: string, metadata?: any, userId?: string) => {
    const shopUrl = new URL(process.env.REACT_APP_APOLLO_HOST as string);
    const { host } = shopUrl;
    const isLocal = true || host.includes('localhost') || isValidIp(host);
    if (!isLocal) {
        Bugsnag.notify(error, function (event) {
            const localUserId = localStorage.getItem('ajs_user_id');
            if (userId) {
                event.setUser(userId);
            } else if (!Bugsnag.getUser().id && localUserId) {
                event.setUser(localUserId);
            }
            if (metadata) {
                event.addMetadata('Metadata', metadata);
            }
            if (context) event.context = context;
        });
    }
};

const isAppInWidgetMode = () => {
    const globalState = store.getState();
    return JSON.parse(globalState?.widget?.isAppInWidgetMode || JSON.stringify(window.top !== window.self));
};

const isWidgetOpened = () => {
    if (sessionStorage) {
        const taffiWidgetOpenedStr = sessionStorage.getItem(WIDGET_CONSTANTS.TAFFI_WIDGET_OPENED);
        return taffiWidgetOpenedStr?.length ? JSON.parse(taffiWidgetOpenedStr) : false;
    }
    return false;
};

const handleRedirectionUrl = (url: string) => {
    if (isAppInWidgetMode()) {
        const globalState = store.getState();
        const storeUrl = globalState?.widget?.store?.url;
        window.parent.postMessage({ taffiRedirectionUrl: url, isMessageFromTaffi: true }, storeUrl);
    } else window.open(url, '_blank');
};

const openLinkInNewTab = (path: string, state?: any) => {
    isAppInWidgetMode() ? (state ? history.push(path, state) : history.push(path)) : window.open(path, '_blank');
};

const openUrl = (url: string, state?: any) => {
    const hostname = new URL(url).hostname;
    const isTaffiUrl = !!constant.TAFFI_DOMAIN.find((d) => hostname.includes(d));
    isAppInWidgetMode() && isTaffiUrl
        ? state
            ? history.push(getPathNameFromUrl(url), state)
            : history.push(getPathNameFromUrl(url))
        : window.open(url, '_blank');
};

const openUrlInSameTab = (path: string) => {
    window.open(path, '_self');
};

const defaulGqlOnError = (err) => {
    console.error(err);
};

const gqlMutationOption = ({
    fetchPolicy = 'network-only',
    onCompleted,
    onError = defaulGqlOnError,
}: IGqlMutationOption) => {
    return {
        fetchPolicy,
        onCompleted: onCompleted,
        onError: onError,
    };
};
const gqlQueryOption = ({
    fetchPolicy = 'cache-first',
    onCompleted,
    onError = defaulGqlOnError,
    variables,
    skip = false,
}: IGqlQueryOption) => {
    return {
        variables,
        fetchPolicy,
        onCompleted: onCompleted,
        onError: onError,
        skip,
    };
};

const getPathNameFromUrl = (url: string) => {
    var parser = document.createElement('a');
    parser.href = url;
    return parser?.pathname;
};

const transformLocalUser = async (transformLocalUserDataMutation) => {
    try {
        if (localStorage.getItem(LOCAL_STORAGE_KEY.LOCAL_USER_KEY)) {
            const localUserData = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY.LOCAL_USER_KEY) as string);
            if (!localUserData.isMerged) {
                const updatedLocalUser = { ...localUserData, isMerged: true };
                localStorage.setItem(LOCAL_STORAGE_KEY.LOCAL_USER_KEY, JSON.stringify(updatedLocalUser));
                await transformLocalUserDataMutation({
                    variables: {
                        input: {
                            userId: JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY.LOCAL_USER_KEY) as string)?.id,
                        },
                    },
                });
            }
        }
    } catch (error) {
        console.error(error);
    }
};

const getLocalUser = () => {
    try {
        const localUserStr = localStorage.getItem(LOCAL_STORAGE_KEY.LOCAL_USER_KEY);
        return localUserStr ? JSON.parse(localUserStr) : null;
    } catch (error) {
        console.log('getLocalUser error=', error);
        return null;
    }
};

const isLocalUser = () => {
    const localUser = getLocalUser();
    return !!localUser?.id;
};

const getItemWithSelectedIndex = (imageJson, item) => {
    let indexSelect = 0;
    if (imageJson && Array.isArray(imageJson) && imageJson.length) {
        const correspondingItemImage = imageJson.find((i) => i.itemId === item.id);
        if (correspondingItemImage) {
            try {
                const findIndex = item.data.images?.findIndex((url) => {
                    const imageJsonUrlObject = new URL(url);
                    const itemImageObject = new URL(correspondingItemImage.url);
                    return imageJsonUrlObject.pathname === itemImageObject.pathname;
                });
                indexSelect = findIndex > -1 ? findIndex : 0;
            } catch (e) {
                indexSelect = 0;
            }
        }
    }
    return {
        ...item,
        indexSelect,
    };
};

const generateListItem = (listItems, id, imageJson, isItemOnly, collection, styleItemData) => {
    if (listItems && listItems.length > 0) {
        let dataTemp: any = [];
        if (isItemOnly) {
            dataTemp = listItems;
        } else {
            dataTemp = [
                {
                    id: id,
                    collection: collection,
                    ...{ data: styleItemData },
                },
                ...listItems,
            ];
        }
        return dataTemp.map((item) => getItemWithSelectedIndex(imageJson, item));
    } else {
        return [];
    }
};

const compareStyleItems = (sourceStyle: any, fixedStyleImageJson: any) => {
    let itemChangePositionText = '';
    let listItemChangePosition = [];
    let listRemovedItems = [];
    const sourceImageJson = sourceStyle.imageJson;
    const fixedImageJson = fixedStyleImageJson;
    const sourceItemIds = sourceImageJson.map((element) => element.itemId);
    const fixedItemIds = fixedImageJson.map((element) => element.itemId);
    const removedItems = difference(sourceItemIds, fixedItemIds);
    if (removedItems.length) {
        listRemovedItems = sourceStyle.items.reduce((items, item) => {
            if (removedItems.includes(item.id)) {
                items.push(item.data.taffiId);
            }
            return items;
        }, []);
    }
    const commonItems = intersection(sourceItemIds, fixedItemIds);
    const sourceCommonItemsImageJson = sourceImageJson.filter((item) => commonItems.includes(item.itemId));
    const fixedCommonItemsImageJson = fixedImageJson.filter((item) => commonItems.includes(item.itemId));
    const changePositionItems = differenceWith(sourceCommonItemsImageJson, fixedCommonItemsImageJson, isEqual);
    if (changePositionItems.length) {
        const changePositionItemIds = changePositionItems.map((item: any) => item.itemId);
        listItemChangePosition = sourceStyle.items.reduce((items, item) => {
            if (changePositionItemIds.includes(item.id)) {
                items.push(item.data.taffiId);
            }
            return items;
        }, []);
        itemChangePositionText = listItemChangePosition.length
            ? `Item ${listItemChangePosition.join(', ')} has changed position.`
            : '';
    }
    return {
        itemChangePositionText,
        listRemovedItems,
        removedItems,
    };
};

const isJson = (str) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};

const handleChunkLoadingError = async (latestVersion, setLatestVersion, error, info = null) => {
    const SyntaxError = 'SyntaxError';
    const ChunkLoadError = 'ChunkLoadError';
    const ChunkErrorMessage = `Unexpected token '<'`;

    if (info) {
        trackEvent(TRACK_EVENT.BUGSNAG_ERROR_FALLBACK, {
            error,
            info,
        });
    }

    if (
        (error.name === SyntaxError && error.message === ChunkErrorMessage) ||
        (error.errorClass === SyntaxError && error.errorMessage === ChunkErrorMessage) ||
        error.errorClass === ChunkLoadError ||
        error.name === ChunkLoadError
    ) {
        const newVersion = await database.realtimeDatabase.ref('config').child('version').get();
        trackEvent(TRACK_EVENT.HANDLE_CHUNK_LOADING_FAIL, {
            version: newVersion.val(),
        });
        if (utils.isAppInWidgetMode()) {
            if (newVersion.val() !== latestVersion) {
                setLatestVersion(newVersion.val());
            }
            window.parent.postMessage(
                {
                    reloadPage: true,
                    path: window.location.pathname,
                    search: window.location.search,
                    isMessageFromTaffi: true,
                    latestVersion: newVersion.val(),
                },
                '*',
            );
        } else {
            window.location.reload();
        }
    }
};

const isMatchedProductUrl = (productUrls: string[], url: string): boolean => {
    return productUrls.some((productUrl) => {
        const urlObject = new URL(url);
        const productUrlObject = new URL(productUrl);
        return urlObject.pathname === productUrlObject.pathname;
    });
};

const getStylesWithUniqItem = (styles: any[], productUrls: string[], styleLayoutVersion = 'v2') => {
    let uniqStyles: any = [];
    const uniqueStyleSet = new Set<string>();
    if (!styles?.length) {
        return [];
    }
    for (const style of styles) {
        let primaryProduct = {};
        if (!uniqueStyleSet.has(style.id)) {
            for (const item of style.items) {
                const urlObject = new URL(item?.data?.url as string);
                const productUrl = `${urlObject.origin}${urlObject.pathname}`;
                if (styleLayoutVersion === DynamicLayoutVersion.v1 && isMatchedProductUrl(productUrls, productUrl)) {
                    primaryProduct = item.data;
                }
                if (styleLayoutVersion === DynamicLayoutVersion.v2 && style.primaryProductUrl) {
                    if (style.primaryProductUrl.includes(productUrl)) {
                        primaryProduct = item.data;
                    } else if (item?.data?.alternativeUrls?.includes(style.primaryProductUrl)) {
                        primaryProduct = { ...item.data, url: style.primaryProductUrl };
                    }
                }
            }
            uniqStyles = [...uniqStyles, { ...style, primaryProduct }];
        }
    }
    return uniqStyles;
};
const getFormattedGender = (gender) => {
    return gender?.toLowerCase().replace('female', 'woman').replace('male', 'man').trim();
};

export const getClientIP = async () => {
    try {
        const ipRes = await fetch('https://geolocation-db.com/json/');
        const data = await ipRes.json();
        return data.IPv4;
    } catch (e) {
        return null;
    }
};

export const getStoreDevAttributes = () => {
    let storeDevAttributes: any = null;
    try {
        const devAttr = sessionStorage.getItem(STORE_DEV_MODE_ATTR);
        if (devAttr) {
            storeDevAttributes = JSON.parse(devAttr);
        }
    } catch (e) {
        console.error('Error read dev attribute from sessionStorage', e);
    }
    return storeDevAttributes;
};

const slackLog = (message: string) => {
    const mobile = JSON.parse(sessionStorage.getItem('isMobile') ?? JSON.stringify(isMobile));
    // slack chanel mobile-debug
    const slack = new Slack('https://hooks.slack.com/services/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');
    if (mobile && process.env.ENABLE_MOBILE_LOG) {
        return slack.send({
            text: message,
        });
    } else {
        console.log(message);
    }
};

const printCallStack = () => {
    console.log(new Error().stack);
};

const correctGender = (gender: string) => {
    return ['female', 'women', 'woman'].includes(gender.toLowerCase()) ? 'female' : 'male';
};

const removeCountryAndLanguageFromUrl = (url: string): string => {
    // apply for url like: https://awspwa.vogacloset.net/saudi/en/...
    try {
        // Parse the URL
        const urlObj = new URL(url);

        // Split the path and remove the first two segments
        const pathSegments = urlObj.pathname.split('/').filter((segment) => segment); // Remove empty segments
        const newPathSegments = pathSegments.slice(2); // Remove country and language

        // Reconstruct the URL
        urlObj.pathname = '/' + newPathSegments.join('/');

        return urlObj.toString();
    } catch (error) {
        console.error('Invalid URL provided:', error);
        return url; // Return the original URL if invalid
    }
};

const getStoreTranslatedString = (key) => {
    const globalState = store.getState();
    const widgetStore = globalState?.widget?.store;
    return widgetStore?.stringTranslator[key] ?? key;
};

export function mapProductDetail(productDetail: any) {
    if (!productDetail) {
        return null;
    }
    const metadata = productDetail.metadata || {};
    const category = metadata.category || '';
    const metadataAttributes = metadata.attributes || [];
    const subcategoryAttributes = metadataAttributes?.find((attr: any) => attr.type === 'Subcategory') || {};
    const subcategory = subcategoryAttributes.value?.length ? subcategoryAttributes.value[0] : '';
    const genderAttribute = metadataAttributes?.find((attr: any) => attr.type === 'Gender') || {};
    const gender = genderAttribute.value?.length ? genderAttribute.value.join(', ') : '';
    return {
        id: productDetail.id,
        url: productDetail.url,
        images: productDetail.images,
        title: productDetail.title,
        description: productDetail.description,
        price: productDetail.price,
        currency: productDetail.currency,
        category,
        subcategory,
        gender,
        brand: productDetail.brand?.name,
        tags: productDetail.tags?.length ? productDetail.tags.map((t: any) => t.name).join(', ') : '',
        sizes: productDetail.sizes?.length ? productDetail.sizes.map((s: any) => s.title).join(', ') : '',
        colors: productDetail.colors?.length ? productDetail.colors.map((c: any) => c.title).join(', ') : '',
        metadataAttributes: metadataAttributes.filter((attr: any) => {
            return (
                attr.type !== 'image_view' &&
                attr.type !== 'OldGender' &&
                attr.type !== 'Material' &&
                attr.value &&
                attr.value.length
            );
        }),
    };
}

const detectSentenceLanguage = (sentence) => {
    let arabicCount = 0;
    let englishCount = 0;

    for (let char of sentence) {
        const code = char.charCodeAt(0);

        if (code >= 0x0600 && code <= 0x06ff) {
            arabicCount++;
        } else if ((code >= 0x0041 && code <= 0x005a) || (code >= 0x0061 && code <= 0x007a)) {
            englishCount++;
        }
    }

    if (arabicCount > englishCount) return { language: 'arabic', code: 'ar' };
    if (englishCount > arabicCount) return { language: 'english', code: 'en' };
    return { language: 'other', code: '' };
};

const utils = {
    TaffiNameStr: TaffiNameStr,
    getAnchorNewTab: getAnchorNewTab,
    getComingSoonElement: getComingSoonElement,
    getHostUrl: getHostUrl,
    getEntityUrl: getEntityUrl,
    objToList: objToList,
    getPreciseFloat: getPreciseFloat,
    getTrimmedStyle: getTrimmedStyle,
    getCorsUrl: getCorsAnyWhereUrl,
    getShareEntityUrl: getShareEntityUrl,
    checkCurrentPage,
    getPrice: getPrice,
    capitalizeString: capitalizeString,
    sortFilterObjectArray,
    getSessionStartandEndTime,
    getSessionStartTimeDisplay,
    getSessionSchedulingStartTime,
    getPersonaSubject: getPersonaSubject,
    getShareEntityUrlWithParams: getShareEntityUrlWithParams,
    isAppInWidgetMode,
    openLinkInNewTab,
    openUrl,
    openUrlInSameTab,
    getViewStyleNotificationParams,
    isMale,
    gqlMutationOption,
    gqlQueryOption,
    getPathNameFromUrl,
    handleRedirectionUrl,
    generateUrlFromPath,
    transformLocalUser,
    isLocalUser,
    getLocalUser,
    generateListItem,
    compareStyleItems,
    getItemWithSelectedIndex,
    isWidgetOpened,
    isJson,
    handleChunkLoadingError,
    getStylesWithUniqItem,
    getFormattedGender,
    slackLog,
    printCallStack,
    correctGender,
    removeCountryAndLanguageFromUrl,
    getStoreTranslatedString,
    mapProductDetail,
    detectSentenceLanguage,
};

export default utils;
